<template>
  <div :ref="listId" class="vue-view vue-view--teams-overview">
    <slot name="filters">
      <div class="vue-view__filters">
        <div class="filters__form">
          <div class="filters__filter mb-4">
            <label>{{ Drupal.t("Search for a team", {}, {'context': 'VueJs Teams search'}) }}</label>
            <div class="filter-keyword-wrapper">
              <FormInput
                  @change="onKeywordChange"
                  :value="model.filter.keyword"
                  class="form-control"
                  :required="false"
                  clearable
              />
              <button type="button" class="btn btn-lg btn-primary" @click="applyFilters()">
                {{ Drupal.t("Search", {}, {'context': 'VueJs Teams search'}) }}
              </button>
            </div>
          </div>

          <div class="filters__filter radios--wrapper">
            <RadioGroupFilter
                :list="this"
                name="type"
                :label="Drupal.t('Select a type of team', {}, {'context': 'VueJs Teams search'})"
                :value="model.filter.type"
                :options="config.actions"
                @update="onTypeChange"/>
          </div>
        </div>
      </div>
    </slot>

    <Spinner v-if="loading"/>

    <div v-if="error">
      <div class="alert alert-danger">{{ error }}</div>
    </div>

    <div class="vue-view__content" :ref="listId + '__content'">
      <div v-if="loaded && !loading && !error">
        <div class="vue-view__results">
          <div v-if="!count">
            <div class="alert alert-info">{{
                Drupal.t("No teams were found.", {}, {'context': 'VueJs Teams search'})
              }}
            </div>
          </div>

          <div v-else>
            <div class="row">
              <template v-for="row in results" :key="row">
                <div class="col-12 mb-4">
                  <div class="kotk-team kotk-team--dkmrun-team view-mode--teaser" :data-id="row.drupal_internal__id">
                    <div class="teaser">
                      <a :href="[path, row.id].join('/')" class="teaser__url">
                        <div class="teaser__content">
                          <div class="teaser__title">{{ row.label }}</div>
                          <div class="teaser__type" v-if="row.type === 'kotk_team--1000kmint_team'">Internationale peloton</div>
                          <div class="teaser__cyclists">{{ row.field_num_teams }}</div>
                        </div>
                      </a>
                    </div>
                  </div>
                </div>
              </template>
            </div>

            <Pagination
                :count="count"
                :result-count="results.length"
                :totalPages="pagination.totalPages"
                :perPage="pagination.perPage"
                :currentPage="pagination.currentPage"
                @pagechanged="pagerClickCallback"
                v-if="pagination.totalPages > 1"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import FormInput from "@/components/Form/FormInput.vue";
import {parse} from "qs";
import Spinner from "@/components/General/SpinnerComponent.vue";
import Pagination from "@/components/Pagination/PaginationComponent.vue";
import TeamsOverview from "@/components/Views/TeamsOverview.vue";
import RadioGroupFilter from "@/components/Filters/RadioGroupFilter.vue";

export default {
  name: "DkmTeamsOverview",
  extends: TeamsOverview,
  components: {
    Pagination, Spinner,
    FormInput,
    RadioGroupFilter,
  },
  data() {
    // Parse our model from the visible query string.
    const queryString = this.$window.location.search.split("?")[1] || ""
    const model = parse(queryString)

    return {
      listId: "teams",
      path: this.$window.location.pathname,
      model: {
        filter: model.filter || { type: "all" },
        page: parseInt(model.page) || 1,
        sort: model.sort || "label",
      },
      config: {
        actions: [
          {id: "all", label: "Alle"},
          {id: "1000km", label: "1000km"},
          {id: "1000kmint", label: "1000km internationaal"},
        ],
        pagination: {
          perPage: 10,
        },
        isMobile: false
      },
      resource: null,
      Drupal: this.$drupal,
      loading: false,
      loaded: false,
      needsRefresh: false,
      error: false,
    }
  },
  computed: {
    actionList() {
      if (!this.model.filter.type || this.model.filter.type === "all") {
        return "1000km,1000kmint"
      }

      return this.model.filter.type
    }
  },
  methods: {
    /**
     * Handle type filter change.
     *
     * @param {Object} value
     */
    onTypeChange(value) {
      if (value === "") {
        value = "all"
      }

      this.model.filter = Object.assign({}, this.model.filter, {
        type: value
      })

      this.applyFilters()
    },

    /**
     * Build the visible query string from our model.
     */
    async resetFilters() {
      this.model = {
        filter: { type: "all" },
        page: 1,
        sort: "label",
      }

      if (this.config.isMobile) {
        this.setModelToQueryString()

        await this.$fetch()
      }
    },

    /**
     * Fetch JSON:API results.
     *
     * @param {Object} settings
     */
    async fetchData(settings) {
      if (this.actionList) {
        const query = this.getQuery(settings)

        this.loading = true
        this.getResults({
          actionId: this.actionList,
          query: query,
        })
        .then(resource => {
          this.resource = resource

          this.loading = false
          this.loaded = true
        }).catch((error) => {
          this.error = Drupal.t("Could not load the teams.", {}, {'context': 'VueJs Teams search'})
          this.loaded = false
        }).finally(() => {
          this.loading = false
        })
      }
    },
  }
}
</script>
